/* ============================================================
   JONI'S — קפיצה לעוגן מתוך תפריט "קולקציות"
   נטען מ-sections/header.liquid. הרכיב: snippets/jonis-shop-submenu.liquid
   העוגנים: sections/featured-collection.liquid, sections/image-banner.liquid

   הבעיה שהקובץ הזה פותר:
   הפריטים בתפריט המשנה מצביעים ל-/pages/gift-shop#col-<handle>. כשכבר
   נמצאים בעמוד הזה, לחיצה על הקישור **אינה מנווטת** — היא רק משנה את
   ה-hash. ל-Dawn אין מושג שזה קרה, ולכן:

     מובייל — HeaderDrawer.openMenuDrawer מוסיף ל-<body> את
              overflow-hidden-tablet. רק closeMenuDrawer מסיר אותו, והוא
              נקרא מכפתור הסגירה, מ-Escape ומה-summary בלבד — לא מלחיצה
              על קישור. התוצאה: הגלילה נעולה, המגירה נשארת פרוסה מעל
              העמוד, והקישור נראה מת לגמרי.

     דסקטופ — HeaderMenu יורש מ-DetailsDisclosure ונסגר רק ב-focusout.
              הפוקוס עובר ל-<a> שנמצא *בתוך* ה-details, ולכן הפאנל
              נשאר פתוח מעל ההדר גם אחרי הקפיצה.

   שים לב: HeaderDrawer.closeMenuDrawer(event, elementToFocus) מוגן פעמיים —
   `if (!elementToFocus) return` שלו, ו-`if (event === undefined) return`
   של MenuDrawer. קריאה בלי שני הארגומנטים לא עושה כלום בשקט.
   ============================================================ */
(function () {
  'use strict';

  var LOCK_CLASSES = ['overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-desktop'];
  var GAP = 20; /* אוויר בין ההדר הדביק לכותרת הסקשן */

  /* ההדר הדביק של הערכה אינו נצמד לראש החלון — הוא נעצר 44px מתחתיו,
     ולכן התחתית שלו היא 116px ולא 72px. `--header-height` מכיר רק את
     הגובה של ההדר עצמו, ולכן scroll-margin-top ב-CSS מחטיא ב-24px
     ומשאיר את ראש הסקשן מאחורי ההדר. מדידה בזמן הלחיצה מדויקת תמיד,
     וגם שורדת שינוי גובה של ההדר בעתיד.
     ה-scroll-margin-top ב-assets/jonis-shop-submenu.css נשאר כגיבוי
     למקרה שהקובץ הזה לא נטען. */
  function stickyBottom() {
    var el = document.querySelector('.section-header');
    if (!el || window.getComputedStyle(el).position !== 'sticky') return 0;
    var bottom = el.getBoundingClientRect().bottom;
    return bottom > 0 ? bottom : 0;
  }

  /* מחזיר את ה-hash רק אם מדובר בקפיצה בתוך אותו עמוד.
     קישור לעמוד אחר מוחזר כ-null — שם הדפדפן מטפל בקפיצה בעצמו. */
  function samePageHash(a) {
    if (!a.hash || a.hash.length < 2) return null;
    if (a.host !== window.location.host) return null;
    var here = window.location.pathname.replace(/\/+$/, '');
    var there = a.pathname.replace(/\/+$/, '');
    return here === there ? a.hash : null;
  }

  function closeMenus(link) {
    var drawer = link.closest('header-drawer, menu-drawer');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(new Event('jonis-jump'), drawer.querySelector('summary'));
    }

    /* רשת ביטחון: אם המגירה שינתה מימוש ונעילת הגלילה שרדה,
       הקישור ייראה מת שוב. עדיף לשחרר במפורש. */
    LOCK_CLASSES.forEach(function (c) {
      document.body.classList.remove(c);
    });

    /* תפריט הדסקטופ, וכל details פתוח שעוטף אותו */
    var details = link.closest('details[open]');
    while (details) {
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      details = details.parentElement ? details.parentElement.closest('details[open]') : null;
    }
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest ? event.target.closest('a[href*="#"]') : null;
    if (!link) return;

    /* רק קישורים בהדר. אנקורים אחרים בעמוד ממשיכים להתנהג כרגיל,
       וקישור הדילוג לתוכן חייב להזיז פוקוס ולא רק לגלול. */
    if (!link.closest('.header-wrapper, .menu-drawer, .jonis-shopnav')) return;
    if (link.classList.contains('skip-to-content-link')) return;

    var hash = samePageHash(link);
    if (!hash) return;

    var target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      return;
    }
    if (!target) return;

    event.preventDefault();
    closeMenus(link);

    /* קריאת offsetHeight מאלצת חישוב פריסה מחדש, וכך שחרור נעילת הגלילה
       נכנס לתוקף לפני הגלילה עצמה. עדיף על requestAnimationFrame, שלא רץ
       כלל במסמך מוסתר — שם הקפיצה הייתה נבלעת בשקט. */
    void document.body.offsetHeight;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyBottom() - GAP;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', hash);
    }
  });
})();
